var MakeAppointmentSummary = {
  init: function () {
    if (Util.getCookie('store_location') != null) {
      MakeAppointmentSummary.showServicesSession();
      MakeAppointmentSummary.showDateTimeSession();
    }
    MakeAppointmentSummary.phoneInputEvents();
  },
  showServicesSession: function () {
    if (sessionStorage.getItem('appointment_services_info')) {
      var info = JSON.parse(sessionStorage.getItem('appointment_services_info'));
      jQuery('#make-appointment-summary-info-services .wrapper').empty();

      if (info.length == 0) {
        jQuery('#make-appointment-summary-info-services .wrapper').append(
          jQuery('<p>').text("No services selected.")
        );
      }
      else {
        // Creates an array of the services names
        var serviceNames = new Array();
        jQuery.each(info, function (key, value) {
          serviceNames.push(value.name);
        });

        // Creates a unique set
        let unique = new Set(serviceNames);

        // Append names to summary sidebar
        unique.forEach(function (value) {
          jQuery('#make-appointment-summary-info-services .wrapper').append(
            jQuery('<p>').text(value)
          );
        })
      }
      jQuery('#make-appointment-summary-info-services').show();
    }
  },
  showDateTimeSession: function () {
    if (sessionStorage.getItem('appointment_datetime')) {
      var info = JSON.parse(sessionStorage.getItem('appointment_datetime'));
      jQuery('#make-appointment-summary-info-date .wrapper').empty();
      if (info.length != 0) {
        jQuery('#make-appointment-summary-info-date .wrapper').append(
          jQuery('<p>').text(info.text)
        );
      }
      jQuery('#make-appointment-summary-info-date').show();
    }
  },
  removeSessionStorages: function () {
    sessionStorage.removeItem('appointment_services_info');
    sessionStorage.removeItem('appointment_datetime');
  },
  /**
  * Auto fill the phone number fields with dashes
  * Modified version of answer from https://stackoverflow.com/a/43750670/3715362
  **/
  phoneInputEvents: function () {
    jQuery("input[type='tel']").each(function () {
      jQuery(this).on('change keyup paste', function (e) {
        let output,
          element = jQuery(this),
          input = element.val();

        if (e.keyCode != 8) {
          input = input.replace(/[^0-9]/g, '');
          let area = input.substr(0, 3);
          let pre = input.substr(3, 3);
          let tel = input.substr(6, 4);
          if (area.length === 0) {
            output = '';
          } else if (area.length > 0 && area.length < 3) {
            output = area;
          } else if (area.length == 3 && pre.length < 3) {
            output = area + '-' + pre;
          } else if (area.length == 3 && pre.length == 3) {
            output = area + '-' + pre + '-' + tel;
          }
          element.val(output);
        }
      });
    });
  }
}